import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type EmailEnviadoLead = {
  id: string;
  campanha: string;
  modelo: string | null;
  serie: string;
  enviado_em: string;
  abriu: boolean | null;
  abriu_em: string | null;
  clicou: boolean | null;
  clicou_em: string | null;
  assinado: string | null;
  caixa_enviada: string | null;
  tem_html: boolean;
};

export function useLeadEmailsEnviados(leadId: string | null) {
  return useQuery({
    queryKey: ["lead-emails-enviados", leadId],
    enabled: !!leadId,
    staleTime: 60_000,
    queryFn: async (): Promise<EmailEnviadoLead[]> => {
      const { data, error } = await supabase.rpc("fn_lead_emails_enviados" as never, { p_lead: leadId } as never);
      if (error) throw error;
      return (Array.isArray(data) ? data : []) as EmailEnviadoLead[];
    },
  });
}

export async function buscarHtmlEnviado(destinatarioId: string): Promise<string | null> {
  const { data, error } = await supabase.rpc("fn_email_destinatario_html" as never, { p_destinatario: destinatarioId } as never);
  if (error) throw error;
  return (data as unknown as string) || null;
}
